import React from 'react';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from '../CardContent/styles/styles.module.scss';
import CardDuration from '../CardDuration';
import CardName from '../CardName';
import CardLength from '../CardLength';
import CardLocation from '../CardLocation';
import Difficulty from '../../shared/Difficulty';
import StarRating from '../../shared/StarRating';
import ReviewCount from '../../shared/ReviewCount';
import CardDescription from '../CardDescription/CardDescription';
import { getAbbrevDescription, getLocalizedName } from '../../../utils/trail_helpers';
import useDisplayMetric from 'hooks/useDisplayMetric';

export default function TrailCardContent({ className, descriptive, displayRank, handleLocationClick, namePaddingRight, trail, url }) {
  const displayMetric = useDisplayMetric();
  const languageRegionCode = useLanguageRegionCode();

  let name = getLocalizedName(trail, languageRegionCode);
  if (displayRank) {
    name = `#${displayRank} - ${name}`;
  }

  const classes = [styles.content];
  if (className) {
    classes.push(className);
  }
  if (descriptive) {
    classes.push(styles.descriptive);
  }

  return (
    <div className={classes.join(' ')}>
      <CardName name={name} paddingRight={namePaddingRight} />
      <CardLocation className={`${styles.info} ${styles.link}`} handleClick={handleLocationClick} paddingRight={namePaddingRight} trail={trail} />
      <div className={`${styles.info} ${styles.thin}`}>
        <Difficulty difficulty={trail.difficulty_rating} />
        <StarRating config={trail.avg_rating} />
        <ReviewCount count={trail.num_reviews} />
      </div>
      <div className={styles.info}>
        <CardLength length={trail.length} displayMetric={displayMetric} languageRegionCode={languageRegionCode} />
        <CardDuration record={trail} isEstimate />
      </div>
      {descriptive && (
        <CardDescription
          className={styles.description}
          name={trail.name}
          description={getAbbrevDescription(trail, displayMetric, languageRegionCode)}
          showMoreUrl={url}
        />
      )}
    </div>
  );
}
